import { IJsonQuery } from '@cian/api-models/common/json_query';

import { TReduxActions } from '../../../types/redux';
import { FILTERS_SELECT_ROOM_TYPE_TYPE } from '../../../constants/action_types';
import { JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function selectRoomTypeReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SELECT_ROOM_TYPE_TYPE:
      const roomTypes = (jsonQuery.room && jsonQuery.room.value) || [];
      const nextRoomTypes = roomTypes.includes(action.roomType)
        ? roomTypes.filter(type => type !== action.roomType)
        : roomTypes.concat(action.roomType);

      return new JsonQuery(jsonQuery).setRoomTypes(nextRoomTypes).getSerializable();
  }

  return jsonQuery;
}
